import App from './App.vue'
import { createApp, h, reactive } from 'vue'
import core_mixin from './mixins/core'
import { translateMixin } from "@/mixins/translate";

const app = createApp({
  onExpand() {},
  render: () => h(App),
});

app
    .mixin(core_mixin)
    .mixin(translateMixin)
    .config.globalProperties.workflowData = reactive({
    meta: {},
    languageSystem: false
})
app.mount('#app')